import { useEffect, useState } from "react";
import InfiniteHorizontalAutoScroll from "../../../components/InfiniteHorizontalAutoScroll/InfiniteHorizontalAutoScroll";
import Titles from "../../../components/Titles/Titles";
import { Allies } from "../../../interfaces/Allies";
import BoxLogos from "../../../components/Cards/BoxLogos";
import ResponsiveContainer from "../../../layouts/ResponsiveContainer";

const SupportInitiative = ({ allies }: { allies: Allies[] }) => {
    const [shouldShowCarousel, setShouldShowCarousel] = useState(false);

    useEffect(() => {
        const updateVisibility = () => {
            const width = window.innerWidth;
    
            let minItems = 2; // Por defecto, en pantallas pequeñas
            
            if (width >= 1280) { // XL (>= 1280px)
                minItems = 5;
            } else if (width >= 1024) { // LG (>= 1024px)
                minItems = 4;
            } else if (width >= 768) { // MD (>= 768px)
                minItems = 3;
            }
    
            setShouldShowCarousel(allies.length > minItems);
        };
    
        updateVisibility();
        window.addEventListener("resize", updateVisibility);
    
        return () => window.removeEventListener("resize", updateVisibility);
    }, [allies.length]);

    return (
        <div className="flex flex-col justify-center w-full items-center mt-16">
            <div className="lg:w-[55rem] xl:w-[70.5rem] w-full flex flex-col items-center">
                <Titles title="Apoyan esta iniciativa"/>
                {shouldShowCarousel
                    ? <InfiniteHorizontalAutoScroll items={allies} />
                    : <ResponsiveContainer className="flex items-center justify-center w-max py-3 gap-8">
                        <BoxLogos displayedItems={allies} />
                    </ResponsiveContainer>
                }
            </div>
        </div>
    );
};

export default SupportInitiative;